import { useState, useEffect } from 'react';

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    deviceInnerScreenWidth: window.screen.width,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        deviceInnerScreenWidth: window.screen.width,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize(); // Call on mount to get initial size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
